import { createFileRoute, useParams } from "@tanstack/react-router";
import { z } from "zod";
import { ProtectedRoute } from "@/components/protected-route";
import { AssetItemDetailPage } from "@/components/inventory/AssetItemDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/asset-items_/$id")({

  validateSearch: z.object({ tab: z.string().optional().catch(undefined) }),
  component: AssetItemDetailRoute,
});

function AssetItemDetailRoute() {
  const { id } = useParams({ from: "/admin/_layout/inventory/asset-items_/$id" });
  const { tab } = Route.useSearch();
  // Same gate as the list page: AssetItemViewSet's read_permission
  // ("inventory.stock.view") covers retrieve too, with no
  // degrade-to-own-rows fallback.
  return (
    <ProtectedRoute requiredPermission="inventory.stock.view">
      <AssetItemDetailPage assetId={id} activeTab={tab} />
    </ProtectedRoute>
  );
}
